import './App.css';

import {Routes, Route } from 'react-router-dom';
import React, { Suspense } from 'react';

import Loading from './common/Loading.js';
const AccountAppRouter = React.lazy(() => import('./account/AccountAppRouter.js'));
const BabyIntroPuzzle = React.lazy(() => import('./BabyIntroPuzzle.js'));
const BandChestnuters = React.lazy(() => import('./BandChestnuters.js'));
const BandFlagdog = React.lazy(() => import('./BandFlagdog.js'));
const BandPaleFire = React.lazy(() => import('./BandPaleFire.js'));
const CorgillogicalAppRouter = React.lazy(() => import('./corgillogical/CorgillogicalAppRouter.js'));
const EmailSubscriptionManager = React.lazy(() => import('./EmailSubscriptionManager.js'));
const EventAppRouter = React.lazy(() => import('./event/EventAppRouter.js'));
const GamesAppRouter = React.lazy(() => import('./games/GamesAppRouter.js'));
const HomeAppRouter = React.lazy(() => import('./home/HomeAppRouter.js'));
const QuizAppRouter = React.lazy(() => import('./quiz/QuizAppRouter.js'));
const RandomNumberGenerator = React.lazy(() => import('./RandomNumberGenerator.js'));
const RhythmAppRouter = React.lazy(() => import('./rhythm/RhythmAppRouter.js'));
const ShopAppRouter = React.lazy(() => import('./shop/ShopAppRouter.js'));
const ShowAppRouter = React.lazy(() => import('./show/ShowAppRouter.js'));
const SokobanAppRouter = React.lazy(() => import('./sokoban/SokobanAppRouter.js'));

export default function App() {
    // This is a url => component mapping. The top level /sokoban route specifies the
    // template being used (Layout component defined above) and the children path
    // specify the detailed component whose content will replace the <Outlet /> element
    // in <Layout />
    return (
        <div className="App">
	    <Suspense fallback={<Loading />}>
		<Routes>
	            <Route path="/account/*" element={<AccountAppRouter />} />
                    <Route path="/sokoban/*" element={<SokobanAppRouter />} />
                    <Route path="/puzzle/*" element={<CorgillogicalAppRouter />} />
                    <Route path="/shop/*" element={<ShopAppRouter />} />
    		    <Route path="/show/*" element={<ShowAppRouter />} />
                    <Route path="/event/*" element={<EventAppRouter />} />
                    <Route path="/quiz/*" element={<QuizAppRouter />} />
                    <Route path="/email/*" element={<EmailSubscriptionManager />} />
                    <Route path="/random/*" element={<RandomNumberGenerator />} />
                    <Route path="/palefire/*" element={<BandPaleFire />} />
                    <Route path="/chestnuters/*" element={<BandChestnuters />} />
                    <Route path="/flatdog/*" element={<BandFlagdog />} />
                    <Route path="/rhythm/*" element={<RhythmAppRouter />} />
		    <Route path="/games/*" element={<GamesAppRouter />} />
		    <Route path="/baby/*" element={<BabyIntroPuzzle />} />
                    <Route path="/*" element={<HomeAppRouter />} />
		</Routes>
	    </Suspense>
        </div>
    );
}
